import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { SelectionModel } from "@angular/cdk/collections";
import { TableResponse } from "../../_model/table-response/table-response";
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  imports: [MatDialogModule, MatButtonModule],
  styleUrls: ['./warning-dialog.component.scss']
})
export class WarningDialogComponent implements OnInit {

  constructor(public dialog: MatDialogRef<WarningDialogComponent>) { }
  selection = new SelectionModel<TableResponse>(true, []);

  ngOnInit() {
  }
  onConfirm(): void {
    this.dialog.close(true);
  }

}
